/** @format */

import { Hidden } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import ThuthukaImage from '../../assets/images/thuthukaLogoVectorHeader.svg';
import { selectApplicant } from '../../features/applicant/ApplicantSlice';
import AccountMenu from '../layout/AccountMenu';
import { sessions } from '../localstorage/SessionStorage';

export default function HomeNavBar() {
  const applicant = useAppSelector(selectApplicant) as any;
  const navigate = useNavigate();

  const renderDisplayName = () => {
    if (applicant.loginState.accessToken && applicant.loginState.accessToken)
      return `Hello, ${applicant.loginState.accessToken?.displayName}`;
    else return '';
  };

  React.useEffect(() => {
    renderDisplayName();
  }, [applicant.loginState.accessToken?.displayName]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static' className='app__home_nav'>
        <Toolbar>
          <Typography
            ml={2}
            variant='h6'
            component='div'
            sx={{ flexGrow: 1 }}
            onClick={() => navigate('/')}
            className='navigation__link nav__title'>
            <Hidden mdUp>
              <img src={ThuthukaImage} alt='logo' width={50} height={50} />
            </Hidden>
            <Hidden mdDown>
              <img src={ThuthukaImage} alt='logo' width={70} height={70} />
            </Hidden>
          </Typography>

          <Box>
            {sessions.getToken() ? (
              <>
                <Hidden mdUp>
                  <AccountMenu />
                </Hidden>
                <Hidden mdDown>
                  <Box
                    component='span'
                    onClick={() => navigate('applicant')}
                    className='navigation__link user_name'>
                    {renderDisplayName()}
                  </Box>
                  <Button
                    style={{
                      color: 'white',
                      backgroundColor: 'red',
                      marginLeft: 16,
                    }}
                    onClick={() => {
                      sessions.removeToken();
                      navigate('/');
                      window.location.reload();
                    }}>
                    Logout
                  </Button>
                </Hidden>
              </>
            ) : (
              <Button color='inherit' onClick={() => navigate('/login')}>
                Login
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
